import { ProcessExecutionStatus } from '@ispm-shared/modules/bpmn';
import { initialState } from '../../store/state';
import { ExecutedPathActions, ExecutedPathActionTypes } from '../../store/actions';

export function processExecutionStatus(state = initialState.processExecutionStatus, action: ExecutedPathActions): ProcessExecutionStatus {
  switch (action.type) {
    case ExecutedPathActionTypes.UPDATE_PROCESS_EXECUTION_STATUS :
      return action.payload.processExecutionStatus;
    default:
      return state;
  }
}
